import { render, staticRenderFns } from "./assist_kpi.vue?vue&type=template&id=4a60f383&scoped=true"
import script from "./assist_kpi.vue?vue&type=script&lang=js"
export * from "./assist_kpi.vue?vue&type=script&lang=js"
import style0 from "./assist_kpi.vue?vue&type=style&index=0&id=4a60f383&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60f383",
  null
  
)

export default component.exports